<template>
  <div id="members-btn">
    <!-- Round Button Style -->
    <button
      v-if="buttonType === 'round'"
      class="round-btn"
      :class="{ 'round-btn--loading': btnLoading }"
      @click="generateLink"
    >
      <svg v-if="!btnLoading" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else class="spinner" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13.5V16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
        <path d="M3.69727 3.69751L5.81977 5.82001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.1802 12.18L14.3027 14.3025" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
        <path d="M1.5 9H4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.5 9H16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
      </svg>
    </button>

    <!-- Text Link Style -->
    <button
      v-else-if="buttonType === 'text'"
      class="text-link-btn"
      @click="generateLink"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3.33334V12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.33334 8H12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Add Members
    </button>

    <!-- Default Button Style -->
    <button
      v-else
      class="primary-btn"
      :disabled="btnLoading"
      @click="generateLink"
    >
      <svg v-if="!btnLoading" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else class="spinner" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 13.5V16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
        <path d="M3.69727 3.69751L5.81977 5.82001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.1802 12.18L14.3027 14.3025" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
        <path d="M1.5 9H4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.5 9H16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/>
      </svg>
      <span>{{ title }}</span>
    </button>

    <!-- Modal -->
    <Teleport to="#teleport-modal">
      <GenerateLinkModal
        v-if="showGenerateLinkModal"
        class="invite-modal"
        @close="closeModal"
      >
        <template v-slot:content>
          <div class="modal-header">
            <div class="modal-header__icon">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5833 19.25V17.4167C15.5833 16.4442 15.197 15.5116 14.5094 14.8239C13.8217 14.1363 12.8891 13.75 11.9167 13.75H4.58333C3.61087 13.75 2.67824 14.1363 1.99061 14.8239C1.30298 15.5116 0.916664 16.4442 0.916664 17.4167V19.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.24999 10.0833C10.2751 10.0833 11.9167 8.44171 11.9167 6.41667C11.9167 4.39162 10.2751 2.75 8.24999 2.75C6.22495 2.75 4.58333 4.39162 4.58333 6.41667C4.58333 8.44171 6.22495 10.0833 8.24999 10.0833Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21.0833 19.25V17.4167C21.0827 16.5957 20.8069 15.7985 20.2989 15.1535C19.7908 14.5084 19.0809 14.0528 18.2833 13.8583" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.6667 2.85834C15.4664 3.05153 16.1787 3.50709 16.6884 4.15311C17.1982 4.79913 17.4748 5.59808 17.4748 6.42084C17.4748 7.2436 17.1982 8.04255 16.6884 8.68857C16.1787 9.33459 15.4664 9.79015 14.6667 9.98334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="modal-header__title">Add Member</h3>
          </div>

          <nav class="modal-tabs">
            <button
              class="modal-tabs__item"
              :class="{ 'modal-tabs__item--active': activeTab === 'Invite link' }"
              @click="switchTab('Invite link')"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.66667 8.66666C6.9531 9.04942 7.31824 9.36612 7.73772 9.59529C8.15721 9.82446 8.62102 9.96074 9.09778 9.99489C9.57454 10.029 10.0531 9.96024 10.5009 9.79319C10.9487 9.62613 11.3554 9.36471 11.6933 9.02666L13.6933 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1986 1.38535 11.3246 1.37775C10.4506 1.37016 9.60864 1.70614 8.98 2.31333L7.83333 3.45333" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.33332 7.33334C9.04689 6.95058 8.68175 6.63388 8.26227 6.40471C7.84278 6.17554 7.37897 6.03926 6.90221 6.00511C6.42545 5.97096 5.94687 6.03977 5.49908 6.20682C5.0513 6.37387 4.6446 6.63529 4.30666 6.97334L2.30666 8.97334C1.69947 9.60201 1.36349 10.444 1.37108 11.318C1.37868 12.192 1.72924 13.028 2.34727 13.6461C2.96529 14.2641 3.80133 14.6147 4.67532 14.6223C5.54931 14.6299 6.39135 14.2939 7.01999 13.6867L8.15999 12.5467" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Invite link
            </button>
            <button
              class="modal-tabs__item"
              :class="{ 'modal-tabs__item--active': activeTab === 'Waitlist link' }"
              @click="switchTab('Waitlist link')"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 4.66666L8 8.66666L2 4.66666" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 4.66666V11.3333C2 11.687 2.14048 12.0261 2.39052 12.2761C2.64057 12.5262 2.97971 12.6667 3.33333 12.6667H12.6667C13.0203 12.6667 13.3594 12.5262 13.6095 12.2761C13.8595 12.0261 14 11.687 14 11.3333V4.66666C14 4.31304 13.8595 3.9739 13.6095 3.72386C13.3594 3.47381 13.0203 3.33333 12.6667 3.33333H3.33333C2.97971 3.33333 2.64057 3.47381 2.39052 3.72386C2.14048 3.9739 2 4.31304 2 4.66666Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Waitlist link
            </button>
          </nav>

          <div class="modal-content">
            <InviteLinkForm
              v-if="activeTab === 'Invite link'"
              :link="link"
              :linkValidTime="linkValidTime"
              :btnLoading="btnLoading"
              :activeTab="activeTab"
              :loading="btnLoading"
              @deactivate="deactivateLink"
              @genLink="generateInviteLink"
            />
            <InviteLinkForm
              v-if="activeTab === 'Waitlist link'"
              :link="waitlist"
              :linkValidTime="listValidTime"
              :btnLoading="btnLoading"
              :activeTab="activeTab"
              :loading="btnLoading"
              @deactivate="deactivateLink"
              @genLink="generateInviteLink"
            />
          </div>
        </template>
      </GenerateLinkModal>
    </Teleport>
  </div>
</template>

<script>
import GenerateLinkModal from "@/components/general/MediumModal";
import InviteLinkForm from "./InviteLinkForm";
import responseHandler from "@/utils/responseHandler.js";
import api from "@/utils/api.js";
import { getItem } from "@/utils/storage";
import { getTimeLeft } from "@/utils/helpers.js";
import { mapActions } from "vuex";

export default {
  name: "DealRoomInvite",
  
  components: {
    InviteLinkForm,
    GenerateLinkModal,
  },
  
  emits: ["gen-link", "view-link"],
  
  data() {
    return {
      triggeredBy: 0,
      showGenerateLinkModal: false,
      activeTab: "Invite link",
      link: "",
      linkId: "",
      linkValidTime: "",
      btnLoading: false,
      waitlist: "",
      waitlistId: "",
      listValidTime: "",
      linkInterval: null,
      waitlistInterval: null,
    };
  },

  props: {
    title: {
      type: String,
      default: () => "",
      required: true,
    },
    buttonType: {
      type: String,
      required: false,
      default: () => "",
    },
  },
  
  beforeUnmount() {
    clearInterval(this.linkInterval);
    clearInterval(this.waitlistInterval);
  },
  
  methods: {
    ...mapActions(["showToast"]),
    
    generateLink() {
      this.triggeredBy = 1;
      this.generateInviteLink();
    },
    
    viewLink() {
      this.triggeredBy = 2;
      this.viewInviteLink();
    },

    calculateTime(link) {
      const listCreatedAt = new Date(link?.createdAt).getTime();
      const expiryDate = new Date(listCreatedAt + link?.valid_period);
      const calculatedTime = getTimeLeft(expiryDate);
      return calculatedTime;
    },

    async viewInviteLink() {
      this.btnLoading = true;
      try {
        let response = await api.viewInviteLink();
        const { data } = response.data;
        data.map((link) => {
          switch (link.waitlist) {
            case true:
              this.waitlist = link?.url;
              this.waitlistId = link?._id;
              this.waitlistInterval = setInterval(() => {
                this.listValidTime = this.calculateTime(link);
              }, 1000);
              break;
            case false:
              this.link = link?.url;
              this.linkId = link?._id;
              this.linkInterval = setInterval(() => {
                this.linkValidTime = this.calculateTime(link);
              }, 1000);
              break;
            default:
              break;
          }
        });
        setTimeout(() => {
          this.showGenerateLinkModal = true;
        }, 1000);
        this.activeTab = "Invite link";
        this.btnLoading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.btnLoading = false;
      }
    },

    async generateInviteLink(regenerate = false) {
      clearInterval(this.linkInterval);
      clearInterval(this.waitlistInterval);
      this.btnLoading = true;
      let originUrl = null;
      const orgId = getItem("org_details")._id;
      switch (window.location.host) {
        case "dealroom.getequity.io":
          originUrl = "https://app.getequity.io";
          break;
        case "founders.getequity.io":
          originUrl = "https://app.getequity.io";
          break;
        default:
          originUrl = "https://staging--getequityinvestors.netlify.app";
          break;
      }
      const url = `${originUrl}/dashboard/deal-room/${orgId}`;
      const link = { waitlist: false, mail_base_url: url, ...(regenerate && { regenerate: true }) };
      const waitlist = { waitlist: true, mail_base_url: url, ...(regenerate && { regenerate: true }) };
      let linkResponse = api.generateInviteLink(link);
      let waitlistResponse = api.generateInviteLink(waitlist);
      try {
        const response = await Promise.all([linkResponse, waitlistResponse]);
        const linkRes = response[0].data.data;
        const waitlistRes = response[1].data.data;
        this.link = linkRes?.link;
        this.waitlist = waitlistRes?.link;
        this.linkId = linkRes?._id;
        this.waitlistId = waitlistRes?._id;
        this.linkInterval = setInterval(() => {
          this.linkValidTime = this.calculateTime(linkRes);
        }, 1000);
        this.waitlistInterval = setInterval(() => {
          this.listValidTime = this.calculateTime(waitlistRes);
        }, 1000);
        this.showGenerateLinkModal = true;
        this.activeTab = "Invite link";
        this.btnLoading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.btnLoading = false;
      }
    },

    async deactivateLink() {
      this.btnLoading = true;
      let id;
      switch (this.activeTab) {
        case "Invite link":
          id = this.linkId;
          break;
        case "Waitlist link":
          id = this.waitlistId;
          break;
        default:
          break;
      }
      try {
        const response = await api.deactivateInviteLink(id);
        const { message } = response.data;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        switch (this.activeTab) {
          case "Invite link":
            this.linkId = "";
            this.link = "";
            this.linkValidTime = "";
            clearInterval(this.linkInterval);
            break;
          case "Waitlist link":
            this.waitlistId = "";
            this.waitlist = "";
            this.listValidTime = "";
            clearInterval(this.waitlistInterval);
            break;
          default:
            break;
        }
        this.btnLoading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.btnLoading = false;
      }
    },

    switchTab(tab) {
      this.activeTab = tab;
    },

    closeModal() {
      clearInterval(this.linkInterval);
      clearInterval(this.waitlistInterval);
      this.showGenerateLinkModal = !this.showGenerateLinkModal;
      this.linkId = "";
      this.link = "";
      this.linkValidTime = "";
      this.waitlistId = "";
      this.waitlist = "";
      this.listValidTime = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.round-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: 2px dashed #CBD5E1;
  border-radius: 50%;
  color: #4D84FF;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(77, 132, 255, 0.05);
    border-color: #4D84FF;
  }

  &--loading {
    background: #4D84FF;
    border-style: solid;
    color: white;
  }
}

.text-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  background: transparent;
  border: none;
  color: #4D84FF;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #3B6EE8;
  }
}

.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: #4D84FF;
  border: none;
  border-radius: 8px;
  color: white;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #3B6EE8;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: #EEF2FF;
    border-radius: 10px;
    color: #4D84FF;
  }

  &__title {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #0F172A;
    margin: 0;
  }
}

.modal-tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: #F1F5F9;
  border-radius: 10px;
  margin-bottom: 24px;

  &__item {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    background: transparent;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: #64748B;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: #0F172A;
    }

    &--active {
      background: white;
      color: #4D84FF;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
  }
}

.modal-content {
  padding: 4px 0;
}
</style>
